module.exports = __webpack_public_path__ + "static/media/share-icon.5c0206c9.svg";